import React from "react"

/**
 * A group's `icon` is whatever the extension declared: a component (heroicons
 * are forwardRef objects, not functions), or a ready element. Answers an
 * element, or undefined when there is none.
 */
export const groupIconElement = (icon, className = "w-4 h-4") => {
  if (!icon) return undefined
  if (React.isValidElement(icon)) return icon
  return React.createElement(icon, { className })
}
